import {TableCellRenderer} from "react-table";
import {formatMoney} from "../coms/siniestros/Deducibles";

export const CellMoney: TableCellRenderer = props => {
    return <div className={"text-right"}>{formatMoney(props.value)}</div>;
};
